//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from 'lodash'
import { cnpj } from 'cpf-cnpj-validator'

export default {
  data() {
    return {
      empty: {
        email: '',
        document: ''
      },
      form: {},
      pageReady: false,
      processing: false,
      isDocumentValid: true
    }
  },

  created() {
    this.setForm()
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      setTimeout(() => {
        this.pageReady = true
      }, 1000)
    },

    setForm() {
      this.form = cloneDeep(this.empty)
    },

    validateDocument() {
      const value = this.form.document
      const target = this.$refs.document

      if (value) {
        const documentNumbers = value.replace(/\D/g, '')
        let isValid = ''

        if (this.form.document) {
          isValid = cnpj.isValid(documentNumbers)
        }

        this.isDocumentValid = isValid

        if (!isValid) {
          target.setCustomValidity(
            'O CNPJ inserido é inválido, revise-o e tente novamente.'
          )
        } else {
          target.setCustomValidity('')
        }

        return isValid
      }
    },

    async send() {
      try {
        // Set processing
        this.processing = true

        // Check user
        await this.$api.auth.checkUser(this.form)

        // Redirect
        this.$router.push({
          path: '/area-restrita/cadastro',
          query: {
            email: this.form.email,
            document: this.form.document
          }
        })
      } catch (err) {
        // Log the error
        console.log(err)

        // Set processing
        this.processing = false

        // Default message
        const error = err.response && err.response.data
        const errorStatus = err.response && err.response.status
        const errorMessage = error && error.message ? error.message : ''
        const message =
          errorStatus === 400 && errorMessage
            ? errorMessage
            : 'Houve um problema ao tentar cadastrar seu usuário, por favor, revise seus dados e tente novamente em alguns instantes.'

        // Show error
        this.$store.dispatch('modal/show', {
          type: 'danger',
          title: 'Erro',
          message
        })
      }
    }
  }
}
